import React, { FC } from "react";
import st from "./BenefitsTile.module.scss";

type Props = {
  backgroundColor: string;
  imageUrl: string;
  heading: string;
  subheading: string;
};

export const BenefitsTile: FC<Props> = ({
  backgroundColor,
  imageUrl,
  heading,
  subheading,
}) => {
  return (
    <div className={st.container} style={{ background: backgroundColor }}>
      <div
        className={st.image}
        style={{ backgroundImage: `url(${imageUrl})` }}
      ></div>
      <div className={st.heading}>{heading}</div>
      <div className={st.text}>{subheading}</div>
    </div>
  );
};
